// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Shipping24FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Shipping24Filled: FC<Shipping24FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="m.5 13.325.5-2h5.5l-.5 2H.5ZM7 20a2.893 2.893 0 0 1-2.125-.875A2.893 2.893 0 0 1 4 17H1.5l.5-2.175h5.175l.9-3.65h2.1l1.25-5H4.5l.15-.6c.1-.467.33-.846.688-1.138A1.94 1.94 0 0 1 6.6 4H18l-.925 4H20l3 4-1 5h-2c0 .833-.292 1.542-.875 2.125A2.893 2.893 0 0 1 17 20a2.893 2.893 0 0 1-2.125-.875A2.893 2.893 0 0 1 14 17h-4c0 .833-.292 1.542-.875 2.125A2.893 2.893 0 0 1 7 20ZM2.5 9.675l.5-2h6.5l-.5 2H2.5ZM7 18c.283 0 .52-.096.713-.288A.968.968 0 0 0 8 17a.968.968 0 0 0-.287-.712A.967.967 0 0 0 7 16a.967.967 0 0 0-.713.288A.968.968 0 0 0 6 17c0 .283.096.52.287.712.192.192.43.288.713.288Zm10 0c.283 0 .52-.096.712-.288A.968.968 0 0 0 18 17a.968.968 0 0 0-.288-.712A.968.968 0 0 0 17 16a.968.968 0 0 0-.712.288A.968.968 0 0 0 16 17c0 .283.096.52.288.712.191.192.429.288.712.288Zm-1.075-5h4.825l.1-.525L19 10h-2.375l-.7 3Z" />
        </svg>
    );
};

export default Shipping24Filled;
